
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

const TestimonialsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Client Testimonials - HP Inc Consulting Services | Safety Consulting Reviews"
        description="Read testimonials from satisfied clients who have worked with HP Inc Consulting Services for OSHA compliance, safety consulting, industrial hygiene, and training services."
        keywords="safety consulting testimonials, OSHA consulting reviews, client testimonials, safety consultant reviews, industrial hygiene testimonials, safety training reviews, workplace safety testimonials"
        canonical="https://hpincconsultant.com/testimonials"
        ogTitle="Client Testimonials - HP Inc Consulting Services Reviews"
        ogDescription="Discover what our clients say about our professional safety consulting services and expertise in workplace safety solutions."
        ogUrl="https://hpincconsultant.com/testimonials"
      />
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-blue-900 to-blue-700 text-white py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Client Testimonials
              </h1>
              <p className="text-xl mb-8">
                What our clients say about our safety consulting services
              </p>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 gap-8">
                <div className="bg-gray-50 p-6 rounded-lg">
                  <div className="flex items-center mb-4">
                    <div className="flex text-yellow-400">
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-4">"HP Inc Consulting Services has been instrumental in transforming our safety culture. Their comprehensive approach to OSHA compliance and employee training has significantly reduced our workplace incidents. The team's expertise and dedication to safety excellence is unmatched in the industry."</p>
                  <div className="font-semibold">- Tony Marichek, East Coast Operations Manager</div>
                  <div className="text-sm text-blue-600 font-medium">Champions Specialty</div>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <div className="flex items-center mb-4">
                    <div className="flex text-yellow-400">
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-4">"Working with HP Inc Consulting Services has been a game-changer for our painting operations. Their industrial hygiene assessments and safety protocols have not only kept our team safe but also improved our operational efficiency. I highly recommend their professional services to any company serious about workplace safety."</p>
                  <div className="font-semibold">- Kevin Lighty</div>
                  <div className="text-sm text-blue-600 font-medium">Ahern Paint</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default TestimonialsPage;
